import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Experiences from './components/Experiences';
import Projects from './components/Projects';
import './App.css';
import searchEngine from './assets/searchengine2.json';
import Weatherapp from './assets/weather.json';
import Nutrition from './assets/nutrition.json';
import AIMessenger from './assets/aimessenger.json';
import doctorwoman from './assets/doctorwoman.json';
import aidcareLogo from './assets/aidcare-logo.jpeg';

function App() {
  const [language, setLanguage] = useState('tr');

  const texts = {
    tr: {
      home: "Ana Sayfa",
      projectsTitle: "Projeler",
      contact: "İletişim",
      name: "Medine Uzun",
      subtitle: "Full-Stack Developer | Mobile & Web",
      description: `Kocaeli Üniversitesi Bilgisayar Mühendisliği mezunu, Full-Stack mimariler üzerine yoğunlaşmış bir Yazılım Mühendisiyim. Teknolojiye olan ilgimi; React Native ve Flutter ile kullanıcı odaklı mobil deneyimler tasarlayarak, Spring Boot ve Python tabanlı backend altyapılarıyla ölçeklenebilir sistemler inşa ederek hayata geçiriyorum. Global Engineer Girls (GEG) programının aktif bir üyesi olarak, kadın mühendislerin sektördeki varlığını güçlendirmeyi hedefliyorum.`,
      github: "GitHub",
      linkedin: "LinkedIn",
      email: "E-Posta Gönder",
      footer: "Tüm hakları saklıdır.",
      experiencesTitle: "Deneyimler",
      experiences: [

        {
          title: "Stajyer Yazılım Mühendisi",
          company: "Uzmar Bilişim Hiz. ve Çöz. Sis. A. Ş.",
          date: "Temmuz 2025 - Ağustos 2025",
          details: [
            "RESTful API prensiplerine uygun olarak Java (Spring Boot) ile ölçeklenebilir backend servisleri geliştirdim ve Flutter mobil arayüzü ile uçtan uca entegrasyon sağladım.",
            "Python kütüphanelerini kullanarak LSTM tabanlı zaman serisi tahmin modelleri eğittim ve yapay zeka çıktılarını canlı sisteme başarıyla entegre ettim.",
            "n8n kullanarak Gmail ve Google Calendar API'lerini entegre ettim; sohbet botu destekli kişiselleştirilmiş bildirimleri ve e-posta iş akışlarını yöneten otomatik bir altyapı kurdum.",
            "Yapay zeka modelleri, otomasyon servisleri ve temel uygulama katmanı arasındaki iletişimi kolaylaştıran modüler bir yazılım mimarisi tasarladım.",
          ]
        },
        {
          title: "Yazılım Ar-Ge Mühendisi",
          company: "Türkiye Sağlık Enstitüleri Başkanlığı (TÜSEB)",
          date: "Ağustos 2024 - Temmuz 2025",
          details: [
            "Diyabet hastaları için geliştirilen yapay zeka destekli sağlık asistanı AIDCARE projesi için kural tabanlı karar destek algoritmaları tasarladım ve temel yazılım mimarisine başarıyla entegre ettim.",
            "Flutter mobil arayüzü, yapay zeka modülleri ve backend servisleri arasında RESTful API'ler üzerinden güçlü iletişim kanalları kurarak asenkron veri akışını uçtan uca yönettim.",
            "Hassas sağlık verilerinin mobil cihaz üzerinde güvenli bir şekilde saklanması için SQLite veritabanı şemasını tasarladım ve veri yönetimi (CRUD) süreçlerini optimize ettim.",
            "Akademik araştırma süreçlerini pratik mühendislik uygulamalarına dönüştürdüm; geliştirilen algoritmaların klinik kanıta dayalı doğrulamasını sağladım ve uluslararası akademik yayın (EEPES 2025) sürecine mühendislik çıktılarım ile katkı sağladım. ",
            "(Makale linki: https://www.mdpi.com/2673-4591/104/1/27)."
          ]
        }
      ],
      project1: {
        name: "AIDCARE",
        desc: "Proje kapsamında; Figma ile kullanıcı deneyimini (UX) odağa alan arayüzler tasarladım ve Flutter ile kodladım . Yapay zeka modülleriyle haberleşen asenkron RESTful API entegrasyonlarını yönettim. Hassas sağlık verilerinin cihaz üzerinde güvenli ve hızlı işlenmesi için SQLite veritabanı şemasını optimize ettim.",
        lang: "Flutter, Figma, SQLite, RESTful API",
        imageLottie: aidcareLogo,
        isLogo: true,
        spanClass: "span-col-2 span-row-2",
        // link: "https://www.mdpi.com/2673-4591/104/1/27"
      },
      project2: {
        name: "AI Destekli Hava Durumu Tahmin Uygulaması",
        desc: `Java (Spring Boot) mimarisiyle RESTful prensiplerine uygun, ölçeklenebilir backend servisleri geliştirdim ve Flutter arayüzüyle uçtan uca entegrasyon sağladım. Python ile eğittiğim LSTM tabanlı hava durumu tahmin modellerini canlı sisteme entegre ederek yüksek doğruluklu veriler sundum.`,
        lang: "Flutter, Spring Boot, Python, LSTM",
        imageLottie: Weatherapp,
        spanClass: "span-col-1 span-row-2"
      },
      project3: {
        name: "n8n Otomasyonlu Chatbot Sistemi",
        desc: `n8n platformu üzerinde Gmail, Google Calendar ve Cohere (AI) API'larını entegre eden modüler bir otomasyon altyapısı kurdum. Yapay zeka destekli chatbot aracılığıyla üretilen kişiselleştirilmiş etkinlik önerilerini otomatik olarak takvime işleyen ve e-posta bildirim süreçlerini uçtan uca yöneten bir sistem geliştirdim.`,
        lang: "n8n, Python, Google Calendar API",
        imageLottie: AIMessenger,
        spanClass: "span-col-1 span-row-2"
      },
      project4: {
        name: "Akademik Makale Öneri/Özetleme Sistemi",
        desc: `Python ve NLP (Doğal Dil İşleme) teknikleri kullanılarak geliştirilmiş makale öneri sistemi. Google Scholar API üzerinden anahtar kelimelerle arama yapar, otomatik özetler üretir ve sonuçlarda aranan kelimeleri vurgular.`,
        lang: "Python, NLP, Google Scholar API",
        imageLottie: searchEngine,
        spanClass: "span-col-2 span-row-1"
      },
      project5: {
        name: "Diyabet Mobil Uygulaması",
        desc: `Python Flask API ve MongoDB ile güvenli veri yönetimi sağlayan, React Native Expotabanlı mobil sağlık asistanı. Diyabet yönetimi için geliştirdiğim kural tabanlı karar destek sistemi sayesinde, kullanıcılara anlık dozaj hesaplamaları ve dinamik eğitim materyalleri sunmaktadır.`,
        lang: "React Native, Python Flask, MongoDB",
        imageLottie: doctorwoman,
        spanClass: "span-col-1 span-row-1"
      },
      project6: {
        name: "Dİyet Web Sİtesi",
        desc: `Node.js ve MongoDB altyapısıyla; diyetisyen ve danışanlar için rol tabanlı (RBAC) kimlik doğrulama, randevu takibi ve beslenme planı yönetimini içeren Full-Stack bir web uygulaması geliştirdim. Tüm sistemi Docker ile konteynerize ederek ölçeklenebilir ve taşınabilir bir mimari kurdum.`,
        lang: "HTML, CSS, JavaScript, Node.js, MongoDB, Docker",
        imageLottie: Nutrition,
        spanClass: "span-col-2 span-row-1"
      }
    },
    en: {
      home: "Home",
      projectsTitle: "Projects",
      contact: "Contact",
      name: "Medine Uzun",
      subtitle: "Full-Stack Developer | Mobile & Web",
      description: `I am a Software Engineer and a Computer Engineering graduate from Kocaeli University, specializing in Full-Stack architectures. I bring my passion for technology to life by designing user-centric mobile experiences with React Native and Flutter, while building scalable backend systems using Spring Boot and Python. As an active member of the Global Engineer Girls (GEG) program, I aim to strengthen the presence of women engineers in the industry.`,
      github: "GitHub",
      linkedin: "LinkedIn",
      email: "Send E-Mail",
      footer: "All rights reserved.",
      experiencesTitle: "Experiences",
      experiences: [
        {
          title: "Software Engineering Intern",
          company: "Uzmar Bilişim Hiz. ve Çöz. Sis. A. Ş.",
          date: "July 2025 - August 2025",
          details: [
            "Developed scalable backend services with Java (Spring Boot) according to RESTful API principles and ensured end-to-end integration with the Flutter mobile interface.",
            "Trained LSTM-based time series forecasting models using Python libraries and successfully integrated AI outputs into the live system.",
            "Integrated Gmail and Google Calendar APIs using n8n; established an automated infrastructure that manages chatbot-supported personalized notifications and email workflows.",
            "Designed a modular software architecture to facilitate communication between AI models, automation services, and the core application layer."
          ]
        },
        {
          title: "Software R&D Engineer",
          company: "Health Institutes of Türkiye (TÜSEB)",
          date: "August 2024 - July 2025",
          details: [
            "Designed rule-based decision support algorithms for the AI-powered health assistant project AIDCARE developed for diabetes patients, and successfully integrated them into the core software architecture.",
            "Managed end-to-end asynchronous data flow by establishing strong communication channels via RESTful APIs between the Flutter mobile interface, AI modules, and backend services.",
            "Designed the SQLite database schema to securely store sensitive health data on mobile devices and optimized data management (CRUD) processes.",
            "Transformed academic research processes into practical engineering applications; provided clinical evidence-based validation of the developed algorithms and contributed to the international academic publication process (EEPES 2025) with my engineering outputs.",
            "(Paper link: https://www.mdpi.com/2673-4591/104/1/27)"
          ]
        }
      ],
      project1: {
        name: "AIDCARE",
        desc: "I designed user experience (UX) focused interfaces with Figma and coded them with Flutter. I managed asynchronous RESTful API integrations communicating with AI modules. I optimized the SQLite database schema for secure and fast processing of sensitive health data on the device.",
        lang: "Flutter, Figma, SQLite, RESTful API",
        imageLottie: aidcareLogo,
        isLogo: true,
        spanClass: "span-col-2 span-row-2",
        // link: "https://www.mdpi.com/2673-4591/104/1/27"
      },
      project2: {
        name: "AI-Powered Weather Forecast App",
        desc: `Developed scalable backend services using Java (Spring Boot) architecture in accordance with RESTful principles, and ensured end-to-end integration with the Flutter interface. Integrated LSTM-based weather prediction models trained with Python into the live system to provide highly accurate data.`,
        lang: "Flutter, Spring Boot, Python, LSTM",
        imageLottie: Weatherapp,
        spanClass: "span-col-1 span-row-2"
      },
      project3: {
        name: "n8n Automated Chatbot System",
        desc: `Built a modular automation infrastructure on the n8n platform integrating Gmail, Google Calendar, and Cohere (AI) APIs. Developed a system that automatically processes personalized event suggestions generated via an AI-supported chatbot into the calendar and manages email notification processes end-to-end.`,
        lang: "n8n, Python, Google Calendar API",
        imageLottie: AIMessenger,
        spanClass: "span-col-1 span-row-2"
      },
      project4: {
        name: "Academic Article Recommender",
        desc: `Article recommendation system developed using Python and NLP (Natural Language Processing) techniques. It performs keyword searches via the Google Scholar API, generates automatic summaries, and highlights searched terms in the results.`,
        lang: "Python, NLP, Google Scholar API",
        imageLottie: searchEngine,
        spanClass: "span-col-2 span-row-1"
      },
      project5: {
        name: "Diabetes Mobile App",
        desc: `React Native Expo-based mobile health assistant providing secure data management with Python Flask API and MongoDB. Thanks to the rule-based decision support system I developed for diabetes management, it offers instant dosage calculations and dynamic educational materials to users.`,
        lang: "React Native, Python Flask, MongoDB",
        imageLottie: doctorwoman,
        spanClass: "span-col-1 span-row-1"
      },
      project6: {
        name: "Dietary Web Application",
        desc: `Developed a Full-Stack web application using Node.js and MongoDB; featuring role-based (RBAC) authentication, appointment tracking, and nutrition plan management for dietitians and clients. Established a scalable and portable architecture by containerizing the entire system with Docker.`,
        lang: "HTML, CSS, JavaScript, Node.js, MongoDB, Docker",
        imageLottie: Nutrition,
        spanClass: "span-col-2 span-row-1"
      }
    }
  };

  const t = texts[language];
  const allProjects = [
    t.project1, t.project2, t.project3, t.project4, t.project5, t.project6, t.project7
  ].filter(Boolean);

  return (
    <div className="app-container">
      {/* Mesh Background */}
      <div className="mesh-container">
        <div className="mesh-blob blob-1"></div>
        <div className="mesh-blob blob-2"></div>
        <div className="mesh-blob blob-3"></div>
      </div>

      <Navbar language={language} setLanguage={setLanguage} t={t} />

      <main className="content-wrapper">
        <Hero t={t} />
        <Experiences t={t} />
        <Projects t={t} allProjects={allProjects} />
      </main>

      <footer className="app-footer">
        <p>© {new Date().getFullYear()} {t.name}. {t.footer}</p>
      </footer>
    </div>
  );
}

export default App;